import { api } from "./client";
import type { Question, QuestionCreate, QuestionUpdate } from "@/types";

export const questionsApi = {
  getAll(
    page = 1,
    pageSize = 20,
    categoryId?: string,
    difficulty?: string,
  ) {
    return api.get<Question[]>("/questions", {
      page,
      page_size: pageSize,
      category_id: categoryId,
      difficulty,
    });
  },

  getById(id: string) {
    return api.get<Question>(`/questions/${id}`);
  },

  create(data: QuestionCreate) {
    return api.post<Question>("/questions", data);
  },

  update(id: string, data: QuestionUpdate) {
    return api.patch<Question>(`/questions/${id}`, data);
  },

  delete(id: string) {
    return api.delete<void>(`/questions/${id}`);
  },
};
